export const BUILD_NUMBER = '730ab7'; export const SEQUENTIAL_BUILD_NUMBER = '1423'; export const PACKAGE_VERSION = '3.3.3';export const SELECTED_THEME = 'smartcr';
